<template>
    <header :class="classes">
        <div :class="`${prefix}-title`">
            <img :class="`${prefix}-local-icon`" src="@/assets/img/tabbar_icon_file_24_pressed.svg">
            <el-breadcrumb>
                <el-breadcrumb-item
                    :class="{ 'el-breadcrumb-item-active': idx !== 0 && (breadcrumb.length - 1) !== idx }"
                    @click.native="handleClick(idx)"
                    v-for="(item, idx) in breadcrumb"
                    :key="idx">
                        {{ item.meta.dynamicTime || item.meta.title }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div :class="`${prefix}-content`">
            <div :class="`${prefix}-content-tabs-wrap`" v-if="showTabs">
                <el-tabs v-model="activeTab" @tab-click="pageTabChange($event.index)">
                    <el-tab-pane :disabled="item.meta.tabDisabled" v-for="(item, idx) in tabs" :label="item.meta.name" :name="item.path" :key="idx"></el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <div :class="`${prefix}-suffix`">
            <w-examine></w-examine>
            <w-user />
        </div>
    </header>
</template>
<script>
const prefix = 'w-page-header'

export default {
    props: {},
    data() {
        return {
            prefix,
            breadcrumb: [],
            tabs: [],
            activeTab: '',
            showTabs: false
        };
    },
    methods: {
        init() {
        },
        handleClick(idx) {
            let breadcrumbLength = this.breadcrumb.length
            let backCount = (breadcrumbLength - 1) - idx
            let currentPosition = breadcrumbLength - 1 === idx
            
            if(!currentPosition && idx > 0) {
                this.$router.go(-backCount)
            }
        },
        filterTab(tabs) {
            let accessIds = JSON.parse(window.localStorage.getItem('adminuseraccess') || '[]')

            return tabs.filter(tab => {
                let meta = tab.meta
                return meta && accessIds.includes(meta.accessId) && meta.name
            })
        },
        findRouter(path) {
            let routersConfig = this.$router.options.routes
            let paths = path.split('/')
            let result
            paths.splice(0, 1)
            paths[0] = `/${paths[0]}`

            let help = (paths, routers) => {
                let path = paths[0]

                routers.find(router => {
                    if(router.path === path) {
                        result = router
                        if(router.children && router.children.length) {
                            paths.splice(0, 1)
                            help(paths, router.children)
                        }
                    }
                })
            }
            help(paths, routersConfig)

            return result
        },
        getadminuseraccess(){
            this.api.adminuseraccess({
                access_token:localStorage.getItem("access_token")
            }).then(da=>{
                localStorage.setItem("adminuseraccess",JSON.stringify(da));
            })
        },
        pageTabChange(idx) {
            let tab = this.tabs[idx]
            let matched = this.$route.matched
            let parentRoute = matched[matched.length - 2]
            let parentShowTabs = parentRoute.meta.showTabs

            if(/^\//.test(tab.path) || parentShowTabs) {
                this.$router.push(tab.path)
            }else {
                let path = matched[matched.length - 1].path
                this.$router.push(`${path}/${tab.path}`)
            }
        },
        setTabs() {
            let meta = this.$route.meta || {}
            let showTabs = meta.showTabs
            let matched = this.$route.matched
            let parentRoute = matched[matched.length - 2]
            let parentShowTabs = parentRoute && parentRoute.meta && parentRoute.meta.showTabs
            

            // 设置tabs
            if(showTabs) {
                let tabs = this.findRouter(this.$route.path).children
                this.tabs = this.filterTab(tabs)
            } else if(parentShowTabs) {
                let tabs = this.findRouter(parentRoute.path).children
                this.tabs = this.filterTab(tabs)
            }else {
                this.tabs = []
            }
            // 设置tabs active
            if(parentShowTabs) {
                let pathPart = this.$route.path.split('/').splice(-1)[0]

                if(this.tabs.find(tab => tab.path === pathPart)) {
                    this.activeTab = pathPart
                }
            }
            if(meta.name) {
                this.showTabs = showTabs || parentShowTabs
            }else {
                this.showTabs = false
            }
            // 默认跳转tab第一个
            if(showTabs && this.tabs.length) {
                this.$router.push(`${this.$route.path}/${this.tabs[0].path}`)
            }
        }
    },
    computed: {
        classes() {
            return [prefix]
        }
    },
    watch: {
        $route: {
            async handler() {
                await this.getadminuseraccess()
                this.setTabs()

                this.$route.matched.forEach(item => {
                    let title = item.meta.title
                    if(typeof title === 'function') {
                        let { params, query } = this.$route
                        title = title({ params, query })
                    }
                    item.meta.dynamicTime = title
                })
                
                // 设置页面标题
                let { dynamicTime, title, name } = this.$route.meta
                if(dynamicTime || title || name) {
                    document.title = (dynamicTime || title || name) + '-狮圈儿运营管理平台'
                }

                this.breadcrumb = this.$route.matched.filter(item => item.meta.title)
            },
            immediate: true
        }
    },
    created() {
        this.init();
    },
};
</script>
<style lang="scss">
@import '~styles/define.scss';

$prefixCls: 'w-page-header';

.#{$prefixCls}{
    height: 60px;
    display: flex;
    align-items: center;
    background-color: $color-white;
    padding: 0 10px;
    &-title{
        display: flex;
        align-items: center;
        min-width: 254px;
    }
    &-local-icon{
        margin-right: 6px;
    }
    &-content{
        flex: 1;
        &-tabs-wrap{
			text-align: center;
			.el-tabs{
				display: inline-block;
				.el-tabs__nav-wrap::after{
					display: none;
				}
				.el-tabs__item{
					line-height: 45px;
					height: 45px;
				}
				.el-tabs__header{
					margin: 0;
				}
			}
		}
    }
    &-suffix{
        min-width: 254px;
        display: flex;
		justify-content: flex-end;
    }
    .el-breadcrumb{
        &-item-active{
            .el-breadcrumb__inner{
                color: #333 !important;
                font-weight: bold;
                transition: color .3s;
                &:hover{
                    color: #33B3FF !important;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>